import { type RoadStatusLayerOptions } from '../Layers/Layers.types';
import { RoadStatusLayer } from '../Layers/RoadStatusLayer';
import TravelTime from '../PopupTemplates/TravelTime';
import { TravelTimeSectionSource } from '../Sources/TravelTimeSectionSource';
import { TravelTimeStatusSource } from '../Sources/TravelTimeStatusSource';

export const travelTime = function (region: string, options?: RoadStatusLayerOptions): RoadStatusLayer {
    const sectionSource = new TravelTimeSectionSource(region);
    const statusSource = new TravelTimeStatusSource(region, { updateInterval: 60 });

    const defaultOptions: RoadStatusLayerOptions = {
        offsetBy: 2,
        color: {
            unknown: '#ccc',
            freeflow: '#17D8A8',
            heavy: '#FFB544',
            congested: '#F23C32',
            impossible: '#811F1F',
        },
        filterByZoom: function (feature, zoom) {
            const roadClass = feature.properties.averageFunctionalRoadClass;
            if (!roadClass || zoom > 10) {
                return true;
            }
            if (zoom < 4) {
                return roadClass < 1;
            }
            if (zoom < 5) {
                return roadClass < 2;
            }
            if (zoom < 6) {
                return roadClass < 3;
            }
            if (zoom < 7) {
                return roadClass < 4;
            }
            if (zoom < 9) {
                return roadClass < 5;
            }
            if (zoom < 10) {
                return roadClass < 6;
            }
            if (zoom < 11) {
                return roadClass < 7;
            }
        },
        getStatus: function (section) {
            return section.status;
        },
        getStatusCode: function (status) {
            const mappedStatuses = {
                unknown: 0,
                freeflow: 1,
                heavy: 2,
                congested: 3,
                impossible: 4,
            };
            return mappedStatuses[status];
        },
        source: sectionSource,
        statusSource: statusSource,
        tooltipTemplate: TravelTime,
    };

    return new RoadStatusLayer({ ...defaultOptions, ...options });
};
